import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { VehicleDefectCode } from '@/types/vehicle-defect-code'

export function createVehicleDefectCode(
  body: VehicleDefectCode
): Promise<AxiosResponse<VehicleDefectCode>> {
  return instance.post(`/vehicle-defect-code`, body)
}
